<script>
    export let top;
    export let rotation = 0;
    $: styles = [
        `--top:${top}vh`,
        `--rotation:${rotation}deg`,
    ];
</script>

<div role="presentation" style={styles.join(";")} on:click={() => document.getElementById("game-list").scrollBy({top:rotation === 0 ? -100 : 100,behavior: "smooth"})}></div>

<style>
    div {
        position: fixed;
        top: var(--top);
        right: 1vh;
        width: 5vh;
        height: 5vh;
        background-image: url(../assets/arrow.png);
        transform: rotate(var(--rotation));
        background-size: contain;
    }
    div:hover {
        background-image: url(../assets/arrow-hover.png);
        transform: rotate(var(--rotation));
    }
</style>
